import { authRoles } from 'app/auth';
import i18next from 'i18next';
import OptimizationPipeline from './component/pipeline/OptimizationPipeline';
import OptimizationPipelineTable from './table/OptimizationPipelineTable';
import OptimizationPipelineEditForm from './editform/OptimizationPipelineEditForm';
import OptimizationPipelineProvider from './component/pipeline/providers/OptimizationPipelineProvider';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'optimizationPipelineV2', en);
i18next.addResourceBundle('hu', 'optimizationPipelineV2', hu);

export default [
	{
		path: '/optimization-pipeline-v2/show/:id',
		component: () => (<OptimizationPipelineProvider><OptimizationPipeline /></OptimizationPipelineProvider>),
		auth: authRoles.optimizationPipelineV2
	},
	{
		path: '/optimization-pipeline-v2/edit/:id',
		component: () => (<OptimizationPipelineProvider><OptimizationPipelineEditForm /></OptimizationPipelineProvider>),
		auth: authRoles.optimizationPipelineV2
	},
	{
		path: '/optimization-pipeline-v2/:sessionNameParam?',
		component: OptimizationPipelineTable,
		auth: authRoles.optimizationPipelineV2
	},
];
